import { css } from 'aphrodite';
import * as React from 'react';
import { MultiContainerHeader } from '../../../../web/components/MultiContainerHeader';
import { TextInput } from '../../../../web/components/TextInput';
import { useEditCampaignTemplateContext } from './context';
import { styleSheet } from './styles';

interface ITitleDisplayProps {
	readonly?: boolean;
	titleText: string;
}

export const TitleDisplayName: React.FC<ITitleDisplayProps> = props => {
	const { readonly, titleText } = props;
	const { displayName, setDisplayName } = useEditCampaignTemplateContext();
	const onTextChanged = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			setDisplayName(e.target.value);
		},
		[setDisplayName]
	);
	return (
		<>
			<MultiContainerHeader fullscreenHeader={titleText} />
			<h1 className={css(styleSheet.header)}>{titleText}</h1>

			<div>
				<label htmlFor='create-social-templates-name-input' className={css(styleSheet.subjectFieldLabel)}>
					Display Name <span className='required'>*</span>
				</label>
				<TextInput
					autoComplete='off'
					className={css(styleSheet.displayNameField)}
					inputId='create-social-templates-name-input'
					onChange={onTextChanged}
					readOnly={readonly}
					type='text'
					value={displayName || ''}
				/>
			</div>
		</>
	);
};
